<div *ngIf="showBanner" class="fixed top-0 left-0 z-[99999] h-[35.5px] w-full bg-red-600 flex items-center justify-center text-xl font-bold tracking-wide text-white shadow-md">
  Ambiente de Desenvolvimento e Homologação
</div>

<ng-container>
  <app-layout class="block pt-[var(--banner-offset)]"></app-layout>
</ng-container>
